import React, { useCallback, useContext, useEffect, useState } from 'react';

import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';
import logger from 'utils/logger.util';
import isNotFn from 'utils/predicates/function/isNotFn.util';

const L = logger('SelectorProvider');

const Context = React.createContext();

export const SelectorProvider = ({ store, children }) => {
  L.debug('()', 'store:', store);
  return <Context.Provider value={store}>{children}</Context.Provider>;
};

export const useStored = (selector) => {
  const store = useContext(Context);
  const [value, setValue] = useState();

  const isNotValid = isNotFn(selector);
  if (isNotValid) L.debug('useStored()', 'Invalid function selector:', selector, 'using:', alwaysNoop);
  const select = isNotValid ? alwaysNoop : selector;

  const listen = useCallback(() => {
    const state = store.getState();
    const value = select(state);
    setValue(value);
  }, [select, store]);

  useEffect(() => store.subscribe(listen), [listen, selector, store]);

  // NOTE: runs it only once on init as to not wait on the subscription to trigger the listener, thus setValue
  useEffect(() => void listen(), [listen]);

  return value;
};
